/**
 * Google Tag Manager 工具模块，负责初始化与事件上报。
 */

/**
 * Google Tag Manager 配置。
 */
export const GTM_ID = "GTM-PGTFLT8B"; // 请替换为您的GTM ID

/**
 * 初始化 GTM 脚本与 dataLayer。
 */
export const initGTM = () => {
	if (typeof window !== "undefined" && window.dataLayer) {
		return;
	}

	// 创建dataLayer
	window.dataLayer = window.dataLayer || [];

	// 创建GTM脚本
	const gtmScript = document.createElement("script");
	gtmScript.async = true;
	gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;

	// 插入脚本到head
	document.head.appendChild(gtmScript);
};

/**
 * 推送事件到 dataLayer。
 * @param {Record<string, unknown>} data 事件数据
 */
export const pushToDataLayer = (data: Record<string, unknown>) => {
	if (typeof window !== "undefined" && window.dataLayer) {
		window.dataLayer.push(data);
	}
};

/**
 * 上报页面浏览事件。
 * @param {string} pagePath 页面路径
 * @param {string} pageTitle 页面标题
 */
export const trackPageView = (pagePath: string, pageTitle?: string) => {
	pushToDataLayer({
		event: "page_view",
		page_path: pagePath,
		page_title: pageTitle ?? "",
	});
};

/**
 * 上报自定义事件。
 * @param {string} eventName 事件名称
 * @param {Record<string, unknown>} parameters 事件参数
 */
export const trackEvent = (
	eventName: string,
	parameters: Record<string, unknown> = {},
) => {
	pushToDataLayer({
		event: eventName,
		...parameters,
	});
};

/**
 * 设置用户属性。
 * @param {Record<string, unknown>} properties 属性数据
 */
export const setUserProperties = (properties: Record<string, unknown>) => {
	pushToDataLayer({
		event: "set_user_properties",
		user_properties: properties,
	});
};
